"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useReducedMotion } from "framer-motion";
import { Check, X } from "lucide-react";
import { Card } from "@/shared/components/ui/card";
import { COMPARISON_ROWS } from "../data/comparison";
import { Reveal } from "./shared/reveal";
export const ComparisonSection = () => {
  const $ = _c(8);
  const reduce = useReducedMotion();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Reveal className="mx-auto max-w-2xl text-center"><span className="text-sm font-semibold uppercase tracking-widest text-zinc-500">Why switch</span><h2 className="mt-3 text-balance text-3xl font-extrabold tracking-tight sm:text-4xl">From chaos to one calm app</h2><p className="mt-4 text-pretty text-muted-foreground">Everything you juggle across spreadsheets and notebooks, in one place.</p></Reveal>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-sm font-semibold uppercase tracking-widest text-zinc-400">Spreadsheets</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Reveal><Card className="h-full border-dashed bg-transparent py-7 shadow-none"><div className="px-6">{t1}<ul className="mt-6 space-y-4">{COMPARISON_ROWS.map(_temp)}</ul></div></Card></Reveal>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-sm font-semibold uppercase tracking-widest text-primary">GymMart</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== reduce) {
    t4 = COMPARISON_ROWS.map((row_0, i) => <motion.li key={row_0.gymmart} initial={reduce ? false : {
      opacity: 0,
      x: 16
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: "-60px"
    }} transition={{
      duration: 0.45,
      delay: i * 0.07,
      ease: [0.22, 1, 0.36, 1]
    }} className="flex items-start gap-3"><span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary"><Check className="size-3" /></span><span className="text-sm font-medium">{row_0.gymmart}</span></motion.li>);
    $[4] = reduce;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <section id="why-switch" className="relative py-20 sm:py-28"><div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">{t0}<div className="mt-14 grid gap-4 md:grid-cols-2">{t2}<Reveal delay={0.1}><Card className="h-full border-primary/40 py-7 shadow-lg shadow-primary/10 ring-1 ring-primary/20"><div className="px-6">{t3}<ul className="mt-6 space-y-4">{t4}</ul></div></Card></Reveal></div></div></section>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(row) {
  return <li key={row.spreadsheet} className="flex items-start gap-3"><span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-zinc-200 text-zinc-500"><X className="size-3" /></span><span className="text-sm text-muted-foreground">{row.spreadsheet}</span></li>;
}